export default {
  logout: {
  } // a namespace is required by i18next
};
